import { cn } from "../../utils";

export interface CheckboxLabelProps {
  className?: string;
  children: React.ReactNode;
}

export const Label = (props: CheckboxLabelProps) => {
  return <span className={cn("truncate", props.className)}>{props.children}</span>;
};
